module.exports = __webpack_public_path__ + "media/fonts/Objectivity-Bold-5532b8ec1c55435db4ab944cae5f259d.woff";